import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { isURL } from 'validator'
import { WebsiteScrapingError } from './BrandVoiceDetectionClient'

export const ScrapeUrlClient = {
  async scrape(website: string, signal?: any, options?: { onAbort: () => void }): Promise<string | null> {
    let url = website
    if (
      !isURL(url, { require_tld: true, require_protocol: true }) &&
      isURL(`https://${url}`, { require_tld: true, require_protocol: true })
    ) {
      // if we can turn `sample` into a valid URL by prepending `https://`, do so
      url = `https://${url}`
    }

    const browserlessResponse = await sendToApi(`/scrape_url`, {
      method: 'POST',
      signal,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ url }),
    })

    if (browserlessResponse.type === 'exception' && browserlessResponse.data.name === 'AbortError') {
      options?.onAbort()
      return null
    }

    if (browserlessResponse.type !== SUCCESS_RESPONSE_TYPE || browserlessResponse.data.length === 0) {
      throw new WebsiteScrapingError({ cause: { url } })
    }

    return browserlessResponse.data
  },
}
